export const RaceJockeyIndexMock = [
    {
        jockeyName: '*Reserve Runner',
        jockeyCareer: '(0: 0-0-0)',

        previousRuns: [
            {
                raceNumber: 7,
                horseNumber: 2,
                horseName: 'DISNEY PRINCESS',
                ownerName: 'Tarry S G'
            },
            {
                raceNumber: 7,
                horseNumber: 2,
                horseName: 'KIR',
                ownerName: 'Bosch D S'
            },
            {
                raceNumber: 7,
                horseNumber: 2,
                horseName: 'STAR SYSTEM',
                ownerName: 'Kotzen N'
            },
            {
                raceNumber: 2,
                horseNumber: 2,
                horseName: 'TURKISH LIRA',
                ownerName: 'Gadsby P M'
            },
            {
                raceNumber: 7,
                horseNumber: 7,
                horseName: 'ISHNANA',
                ownerName: 'Puller G B'
            },
            {
                raceNumber: 10,
                horseNumber: 10,
                horseName: 'ON THAT BOULEVARD',
                ownerName: 'Rivalland A J'
            },
            {
                raceNumber: 2,
                horseNumber: 5,
                horseName: 'QUATRO FIVE SIX',
                ownerName: 'Govender Y'
            },
            {
                raceNumber: 8,
                horseNumber: 4,
                horseName: 'BELLE OF PARIS',
                ownerName: 'Puller G B'
            },
            {
                raceNumber: 4,
                horseNumber: 9,
                horseName: 'GORGEOUS GUEST',
                ownerName: 'Van Zyl G H'
            },
            {
                raceNumber: 6,
                horseNumber: 5,
                horseName: 'TWICE AS SPECIAL',
                ownerName: 'Nassif A'
            }
        ]
    },
    {
        jockeyName: 'Arries A',
        jockeyCareer: '(310: 16-23-34)',
        previousRuns: [
            {
                raceNumber: 7,
                horseNumber: 7,
                horseName: 'ISHNANA',
                ownerName: 'Puller G B'
            },
            {
                raceNumber: 10,
                horseNumber: 10,
                horseName: 'ON THAT BOULEVARD',
                ownerName: 'Rivalland A J'
            },
            {
                raceNumber: 2,
                horseNumber: 5,
                horseName: 'QUATRO FIVE SIX',
                ownerName: 'Govender Y'
            },
            {
                raceNumber: 8,
                horseNumber: 4,
                horseName: 'BELLE OF PARIS',
                ownerName: 'Puller G B'
            },
            {
                raceNumber: 4,
                horseNumber: 9,
                horseName: 'GORGEOUS GUEST',
                ownerName: 'Van Zyl G H'
            }
        ]
    },
    {
        jockeyName: 'De Melo K',
        jockeyCareer: '(739: 87-88-93)',
        previousRuns: [
            {
                raceNumber: 2,
                horseNumber: 5,
                horseName: 'QUATRO FIVE SIX',
                ownerName: 'Govender Y'
            },
            {
                raceNumber: 8,
                horseNumber: 4,
                horseName: 'BELLE OF PARIS',
                ownerName: 'Puller G B'
            },
            {
                raceNumber: 4,
                horseNumber: 9,
                horseName: 'GORGEOUS GUEST',
                ownerName: 'Van Zyl G H'
            },
            {
                raceNumber: 6,
                horseNumber: 5,
                horseName: 'TWICE AS SPECIAL',
                ownerName: 'Nassif A'
            },
            {
                raceNumber: 4,
                horseNumber: 9,
                horseName: 'RIPTIDE',
                ownerName: 'Tarryn S G'
            }
        ]
    },
    {
        jockeyName: 'Ferraris L J',
        jockeyCareer: '(741: 69:67-56)',
        previousRuns: [
            {
                raceNumber: 7,
                horseNumber: 2,
                horseName: 'KIR',
                ownerName: 'Bosch D S'
            },
            {
                raceNumber: 7,
                horseNumber: 2,
                horseName: 'STAR SYSTEM',
                ownerName: 'Kotzen N'
            },
            {
                raceNumber: 2,
                horseNumber: 2,
                horseName: 'TURKISH LIRA',
                ownerName: 'Gadsby P M'
            },
            {
                raceNumber: 7,
                horseNumber: 7,
                horseName: 'ISHNANA',
                ownerName: 'Puller G B'
            },
            {
                raceNumber: 10,
                horseNumber: 10,
                horseName: 'ON THAT BOULEVARD',
                ownerName: 'Rivalland A J'
            },
            {
                raceNumber: 2,
                horseNumber: 5,
                horseName: 'QUATRO FIVE SIX',
                ownerName: 'Govender Y'
            },
            {
                raceNumber: 8,
                horseNumber: 4,
                horseName: 'BELLE OF PARIS',
                ownerName: 'Puller G B'
            }
        ]
    },
    {
        jockeyName: 'Fourie R',
        jockeyCareer: '(558: 121-77-87)',
        previousRuns: [
            {
                raceNumber: 7,
                horseNumber: 2,
                horseName: 'DISNEY PRINCESS',
                ownerName: 'Tarry S G'
            },
            {
                raceNumber: 7,
                horseNumber: 2,
                horseName: 'KIR',
                ownerName: 'Bosch D S'
            },
            {
                raceNumber: 7,
                horseNumber: 2,
                horseName: 'STAR SYSTEM',
                ownerName: 'Kotzen N'
            },
            {
                raceNumber: 7,
                horseNumber: 2,
                horseName: 'DISNEY PRINCESS',
                ownerName: 'Tarry S G'
            },
            {
                raceNumber: 7,
                horseNumber: 2,
                horseName: 'DISNEY PRINCESS',
                ownerName: 'Tarry S G'
            }
        ]
    },
    {
        jockeyName: 'Gates',
        jockeyCareer: '(277: 32-25-26)',
        previousRuns: [
            {
                raceNumber: 4,
                horseNumber: 9,
                horseName: 'GORGEOUS GUEST',
                ownerName: 'Van Zyl G H'
            },
            {
                raceNumber: 6,
                horseNumber: 5,
                horseName: 'TWICE AS SPECIAL',
                ownerName: 'Nassif A'
            },
            {
                raceNumber: 4,
                horseNumber: 9,
                horseName: 'RIPTIDE',
                ownerName: 'Tarryn S G'
            },
            {
                raceNumber: 4,
                horseNumber: 9,
                horseName: 'MAMBA DUKE',
                ownerName: 'Binda C'
            }
        ]
    },
    {
        jockeyName: 'Godden T',
        jockeyCareer: '(74: 3-2-5)',
        previousRuns: [
            {
                raceNumber: 7,
                horseNumber: 2,
                horseName: 'DISNEY PRINCESS',
                ownerName: 'Tarry S G'
            },
            {
                raceNumber: 7,
                horseNumber: 2,
                horseName: 'KIR',
                ownerName: 'Bosch D S'
            },
            {
                raceNumber: 7,
                horseNumber: 2,
                horseName: 'STAR SYSTEM',
                ownerName: 'Kotzen N'
            },
            {
                raceNumber: 7,
                horseNumber: 2,
                horseName: 'DISNEY PRINCESS',
                ownerName: 'Tarry S G'
            },
            {
                raceNumber: 7,
                horseNumber: 2,
                horseName: 'DISNEY PRINCESS',
                ownerName: 'Tarry S G'
            }
        ]
    },
    {
        jockeyName: 'Hewitson L',
        jockeyCareer: '(1249: 175-190-139)',
        previousRuns: [
            {
                raceNumber: 7,
                horseNumber: 7,
                horseName: 'ISHNANA',
                ownerName: 'Puller G B'
            },
            {
                raceNumber: 10,
                horseNumber: 10,
                horseName: 'ON THAT BOULEVARD',
                ownerName: 'Rivalland A J'
            },
            {
                raceNumber: 2,
                horseNumber: 5,
                horseName: 'QUATRO FIVE SIX',
                ownerName: 'Govender Y'
            },
            {
                raceNumber: 8,
                horseNumber: 4,
                horseName: 'BELLE OF PARIS',
                ownerName: 'Puller G B'
            },
            {
                raceNumber: 4,
                horseNumber: 9,
                horseName: 'GORGEOUS GUEST',
                ownerName: 'Van Zyl G H'
            },
            {
                raceNumber: 6,
                horseNumber: 5,
                horseName: 'TWICE AS SPECIAL',
                ownerName: 'Nassif A'
            }
        ]
    },
    {
        jockeyName: 'Jacobsen B',
        jockeyCareer: '(84: 8-9-2)',
        previousRuns: [
            {
                raceNumber: 7,
                horseNumber: 2,
                horseName: 'DISNEY PRINCESS',
                ownerName: 'Tarry S G'
            },
            {
                raceNumber: 7,
                horseNumber: 2,
                horseName: 'DISNEY PRINCESS',
                ownerName: 'Tarry S G'
            }
        ]
    },
    {
        jockeyName: 'Kennedy W',
        jockeyCareer: '(986: 108-128-117)',
        previousRuns: [
            {
                raceNumber: 8,
                horseNumber: 4,
                horseName: 'BELLE OF PARIS',
                ownerName: 'Puller G B'
            },
            {
                raceNumber: 4,
                horseNumber: 9,
                horseName: 'GORGEOUS GUEST',
                ownerName: 'Van Zyl G H'
            },
            {
                raceNumber: 6,
                horseNumber: 5,
                horseName: 'TWICE AS SPECIAL',
                ownerName: 'Nassif A'
            },
            {
                raceNumber: 4,
                horseNumber: 9,
                horseName: 'RIPTIDE',
                ownerName: 'Tarryn S G'
            },
            {
                raceNumber: 4,
                horseNumber: 9,
                horseName: 'MAMBA DUKE',
                ownerName: 'Binda C'
            }
        ]
    },
    {
        jockeyName: 'Khan M',
        jockeyCareer: '(468: 50-47-40)',
        previousRuns: [
            {
                raceNumber: 7,
                horseNumber: 2,
                horseName: 'DISNEY PRINCESS',
                ownerName: 'Tarry S G'
            },
            {
                raceNumber: 7,
                horseNumber: 2,
                horseName: 'DISNEY PRINCESS',
                ownerName: 'Tarry S G'
            },
            {
                raceNumber: 4,
                horseNumber: 9,
                horseName: 'RIPTIDE',
                ownerName: 'Tarryn S G'
            },
            {
                raceNumber: 4,
                horseNumber: 9,
                horseName: 'MAMBA DUKE',
                ownerName: 'Binda C'
            }
        ]
    }
];
